// @flow

import React from 'react';
import styles from './loader.scss';

const loaderImgUrl = require('../../../assets/images/loader.gif');

type Props = {
  message?: string,
  inputLoaderUrl?: string,
  customStyles?: object,
  imgStyles?: object,
  messageStyles?: Object
};

const Loader = (props: Props) => {
  let customStyles = {};
  let imgStyles = {};
  let messageStyles = {};
  if (props.customStyles) {
    customStyles = props.customStyles;
  }
  if (props.imgStyles) {
    imgStyles = props.imgStyles;
  }
  if (props.messageStyles) {
    messageStyles = props.messageStyles;
  }
  return (
    <div
      style={customStyles}
      className={` ${styles.loaderIcnWrapper} l-row a-center j-center `}
    >
      <div className={styles.loaderImg}>
        <img
          className={styles.loaderIcn}
          style={imgStyles}
          src={props.inputLoaderUrl ? props.inputLoaderUrl : loaderImgUrl}
          alt="Loading..."
        />
      </div>
      <div className={styles.loadingMsg} style={messageStyles}>
        {props.message}
      </div>
    </div>
  );
};

Loader.defaultProps = {
  message: 'Loading...'
};

export default Loader;
